import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LOCALE, LOCALES } from '@cgp/shared'

import commonEn from './locales/en/common.json'
import authEn from './locales/en/auth.json'
import gateEn from './locales/en/gate.json'
import registrationEn from './locales/en/registration.json'
import hseEn from './locales/en/hse.json'
import adminEn from './locales/en/admin.json'
import notificationsEn from './locales/en/notifications.json'
import commonVi from './locales/vi/common.json'
import authVi from './locales/vi/auth.json'
import gateVi from './locales/vi/gate.json'
import registrationVi from './locales/vi/registration.json'
import hseVi from './locales/vi/hse.json'
import adminVi from './locales/vi/admin.json'
import notificationsVi from './locales/vi/notifications.json'

/**
 * Namespaces: common | auth | registration | hse | gate | admin | notifications.
 * Vietnamese is the default and also the fallback — an untranslated key must
 * never render as a raw key to a user at the gate.
 */
export const NAMESPACES = ['common', 'auth', 'registration', 'hse', 'gate', 'admin', 'notifications'] as const

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        auth: authEn,
        gate: gateEn,
        registration: registrationEn,
        hse: hseEn,
        admin: adminEn,
        notifications: notificationsEn,
      },
      vi: {
        common: commonVi,
        auth: authVi,
        gate: gateVi,
        registration: registrationVi,
        hse: hseVi,
        admin: adminVi,
        notifications: notificationsVi,
      },
    },
    supportedLngs: [...LOCALES],
    fallbackLng: DEFAULT_LOCALE,
    defaultNS: 'common',
    ns: ['common', 'auth', 'gate', 'registration', 'hse', 'admin', 'notifications'],
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'cgp.locale',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  })

export default i18next
